let emManutencao = false;
const listeners = new Set();

export function getManutencao() {
  return emManutencao;
}

export function setManutencao(valor) {
  if (emManutencao === valor) return;
  emManutencao = valor;
  listeners.forEach((listener) => listener(valor));
}

export function subscribeManutencao(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
